import React from 'react';

export default function TheySayStatic({ description }: { description: string }) {
  return (
    <p>
      <span className="they-say__quote">“</span>
      <span dangerouslySetInnerHTML={{ __html: description }} />
      <span className="they-say__quote">”</span>
    </p>
  );
}
